import type { GlobalAppStateStoreInstance } from '@unifyapps/carbon/no-code/stores/app/GlobalAppStateStore/selectors';
import type { GlobalStateStoreInstance } from '@unifyapps/carbon/no-code/stores/GlobalStateStore/GlobalStateStoreManager';
import type { RunnerInterfaceStoreSelectors } from '@unifyapps/carbon/no-code/stores/InterfaceStore/runner/selectors';
import { createContext } from 'use-context-selector';
import type { useDependencyGraphProvider } from '../../../context/DependencyGraphProvider';
import type { UseNonReactiveComputeContextType } from '../../../hooks/computeContext';
import type { UseIsEntitySuspended } from '../../../hooks/useIsEntitySuspended';

type PageFunctionControllerContextType = {
  useNonReactiveComputeContext: UseNonReactiveComputeContextType;
  useInterfaceStore: () => RunnerInterfaceStoreSelectors;
  useGlobalStateStore: () => GlobalStateStoreInstance | GlobalAppStateStoreInstance;

  useDependencyGraphProvider: typeof useDependencyGraphProvider;

  useTriggerAutomaticDataSources: (params: { dataSourceIds?: string[] }) => void;
  useIsEntitySuspended: UseIsEntitySuspended;
};

export const PageFunctionControllerContext =
  createContext<PageFunctionControllerContextType | null>(null);

export type { PageFunctionControllerContextType };
